import React from 'react';
import { Image, Text, View, } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import Box from '../Box';
import Flex from '../Flex';
import { useTagStyle } from './style';
export function Tag(props) {
    var _a, _b, _c;
    const { children, type = 'primary', style, leftText, rightText, textStyle, textProps, boxStyle: outerBosStyle, linearGradient, onPress, } = props || {};
    const { tagStyle, boxStyle } = useTagStyle();
    if (type === 'flash') {
        return (React.createElement(Flex, { flex: 'flexRowCenter' },
            React.createElement(LinearGradient, { useAngle: true, angle: 90, start: { x: 0.0, y: 0.0 }, end: { x: 1.0, y: 0.0 }, colors: ['#FF4906', '#FF7033'], style: tagStyle.linearGradient },
                React.createElement(Text, { style: tagStyle.flashLeftText }, leftText)),
            React.createElement(View, { style: tagStyle.flashIconBox },
                React.createElement(Image, { style: tagStyle.flashIcon, source: {
                        uri: 'https://g-static.ap4r.com/kos/s101/nlav11312/shop-c-h5/flash.png',
                    } })),
            React.createElement(View, { style: tagStyle.flashRight },
                React.createElement(Text, { style: tagStyle.flashRightText }, rightText))));
    }
    if (linearGradient) {
        const map = {
            horizontal: {
                start: { x: 0.0, y: 0.0 },
                end: { x: 1.0, y: 0.0 },
            },
            vertical: {
                start: { x: 0.0, y: 0.0 },
                end: { x: 0.0, y: 1.0 },
            },
        };
        const mapVal = map[(_a = linearGradient.direction) !== null && _a !== void 0 ? _a : 'horizontal'];
        const linearNode = (React.createElement(LinearGradient, { useAngle: true, angle: 90, start: (_b = linearGradient.start) !== null && _b !== void 0 ? _b : mapVal.start, end: (_c = linearGradient.end) !== null && _c !== void 0 ? _c : mapVal.end, colors: linearGradient.colors, style: [tagStyle.base, outerBosStyle] },
            React.createElement(Text, Object.assign({}, textProps, { style: [
                    tagStyle.textBase,
                    tagStyle[type],
                    style,
                    textStyle,
                ] }), children)));
        if (onPress) {
            return (React.createElement(Box, { style: { alignSelf: 'baseline' }, withoutBox: true, onPress: onPress }, linearNode));
        }
        return linearNode;
    }
    function renderChildNode() {
        if (React.isValidElement(children))
            return children;
        return (React.createElement(Text, Object.assign({}, textProps, { ellipsizeMode: "tail", numberOfLines: 1, style: [tagStyle.textBase, tagStyle[type], style, textStyle] }), children));
    }
    return (React.createElement(Box, { nativeID: "MetaTag", style: [
            tagStyle.base,
            linearGradient ? {} : boxStyle[type],
            outerBosStyle,
        ], onPress: onPress }, renderChildNode()));
}
export default Tag;
